export const FORM_POST_REDIRECT_SUBMIT_BUTTON_ID = '__form_post_redirect_submit_button__';
